import Checkbox from './Checkbox';
import { withFormMeta } from '../../FormMeta';

export default withFormMeta(Checkbox);
